var $8fa6587f11fa2728$exports = {};
$8fa6587f11fa2728$exports = {
    "(optional)": `(opcion\xe1lis)`,
    "(required)": `(k\xf6telez\u{151})`
};


export {$8fa6587f11fa2728$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
